export default __webpack_public_path__ + "static/media/327.9719b58e.png";